// As 4 etapas da tela de cliente (prints dela, 10/10/2026). So a ordem e os
// nomes moram aqui; o que cada etapa mostra mora em paginas/clientes/FormCliente.tsx.
export const ETAPAS_CADASTRO = [
  { id: 'dados', rotulo: 'Dados' },
  { id: 'endereco', rotulo: 'Endereço' },
  { id: 'comercial', rotulo: 'Comercial' },
  { id: 'historico', rotulo: 'Histórico' },
] as const

export type EtapaCadastro = (typeof ETAPAS_CADASTRO)[number]['id']

function indice(etapa: EtapaCadastro): number {
  return ETAPAS_CADASTRO.findIndex((e) => e.id === etapa)
}

// "2 de 4": conta a partir de 1.
export function posicaoDaEtapa(etapa: EtapaCadastro): number {
  return indice(etapa) + 1
}

export function proximaEtapa(etapa: EtapaCadastro): EtapaCadastro | null {
  return ETAPAS_CADASTRO[indice(etapa) + 1]?.id ?? null
}

export function etapaAnterior(etapa: EtapaCadastro): EtapaCadastro | null {
  return ETAPAS_CADASTRO[indice(etapa) - 1]?.id ?? null
}

// O visto do print vai nas etapas que ficaram para tras, nao na atual.
export function etapaJaPassada(etapa: EtapaCadastro, atual: EtapaCadastro): boolean {
  return indice(etapa) < indice(atual)
}
